export default "__VITE_ASSET__DGXuBp2M__"